export enum SolarProductType {
    STORAGE_ONLY = 'Storage Only',
    STORAGE_AND_PANEL = 'Storage and Panel'
}